import React, { Fragment } from 'react';

import { ReactComponent as IconClose } from './images/iconsax/close-circle.svg'
import { ReactComponent as IconTick } from './images/iconsax/tick-circle.svg'
import { ReactComponent as IconClock } from './images/iconsax/clock.svg'
import { ReactComponent as IconWarningBlue } from './images/iconsax/warning-circle-blue.svg'

import { ReactComponent as IconHome } from './images/iconsax/house.svg'
import { ReactComponent as IconCloud } from './images/iconsax/cloud.svg'
import { ReactComponent as IconDownload } from './images/iconsax/download.svg'
import { ReactComponent as IconMessage } from './images/iconsax/message.svg'
import { ReactComponent as IconLayers } from './images/iconsax/layers.svg'

import { ReactComponent as IconHinavaLoading } from './images/hinava-loading/HinavaLoading.svg'
import { ReactComponent as IconHinavaLogo } from './images/hinava-loading/HinavaLogo.svg'

import useData, { StatusType } from './Data';

import './App.scss';

const statusColorName = {
  "active": "green",
  "recover": "blue",
  "maintain": "yellow",
  "failure": "red",
}

const statusText = {
  "active": "This service is working well",
  "recover": "There was a problem recently but now it's recovered",
  "maintain": "System is under maintenance",
  "failure": "We've found a problem",
}

function StatusIconAndText({ status }) {
  let image = IconClose;
  if (status === "active") {
    image = IconTick;
  } else if (status === "recover") {
    image = IconWarningBlue;
  } else if (status === "maintain") {
    image = IconClock;
  }

  return <div className="status-group">
    {React.createElement(image, { className: "icon" })}
    <div className="status">{statusText[status]}</div>
  </div>
}

function locale(t) {
  if (!t) {
    t = Date.now() / 1000;
  }
  const d = new Date(t * 1000);
  return `last check ${d.toLocaleTimeString()}`;
}


function App() {
  const { loadedOnce, cards: {
    kavenegar,
    dbFirmwareVersions,
    autoSoloDevices,
    autoGw,
    fileDownload
  } } = useData();

  return (
    <Fragment>
      <div className={"loading " + (loadedOnce ? "inactive" : "active")}><IconHinavaLoading /></div>
      <div className="container">
        <div className="title">
          <IconHinavaLogo className="icon" />
          <div className="text">Hinava Status</div>
        </div>
        <div className="cards">

          {
            autoGw.status !== StatusType.Hidden ?
              <div className={"card " + statusColorName[autoGw.status]}>
                <div className="title-group">
                  <IconHome className="icon" />
                  <div className="title">Hub Connection</div>
                </div>
                <StatusIconAndText status={autoGw.status} />
                <div className="lastcheck italic">{locale(autoGw.lastTime)}</div>
              </div> : null
          }

          {
            autoSoloDevices.status !== StatusType.Hidden ?
              <div className={"card " + statusColorName[autoSoloDevices.status]}>
                <div className="title-group">
                  <IconCloud className="icon" />
                  <div className="title">Solo Device Connection</div>
                </div>
                <StatusIconAndText status={autoSoloDevices.status} />
                <div className="lastcheck italic">{locale(autoSoloDevices.lastTime)}</div>
              </div> : null
          }

          {
            fileDownload.status !== StatusType.Hidden ?
              <div className={"card " + statusColorName[fileDownload.status]}>
                <div className="title-group">
                  <IconDownload className="icon" />
                  <div className="title">Installation & Update</div>
                </div>
                <StatusIconAndText status={fileDownload.status} />
                <div className="lastcheck italic">{locale(fileDownload.lastTime)}</div>
              </div> : null
          }

          {
            kavenegar.status !== StatusType.Hidden ?
              <div className={"card " + statusColorName[kavenegar.status]}>
                <div className="title-group">
                  <IconMessage className="icon" />
                  <div className="title">SMS & Call</div>
                </div>
                <StatusIconAndText status={kavenegar.status} />
                <div className="lastcheck italic">{locale(kavenegar.lastTime)}</div>
              </div> : null
          }

          {
            dbFirmwareVersions.status !== StatusType.Hidden ?
              <div className={"card " + statusColorName[dbFirmwareVersions.status]}>
                <div className="title-group">
                  <IconLayers className="icon" />
                  <div className="title">Internal Services</div>
                </div>
                <StatusIconAndText status={dbFirmwareVersions.status} />
                <div className="lastcheck italic">{locale(dbFirmwareVersions.lastTime)}</div>
              </div> : null
          }

        </div>
      </div>
    </Fragment>
  );
}

export default App;
